import DownloadApp from "./steps/DownloadApp";
import ScanQRCode from "./steps/ScanQRCode";
import BackupKey from "./steps/BackupKey";
import EnabledGoogleAuthenticator from "./steps/EnabledGoogleAuthenticator";
import DisableGoogleAuthenticator from "./steps/DisableGoogleAuthenticator";

export const STEPS = [
  { label: 'Download App', description: "Download and install the Google Authenticator app", component: DownloadApp },
  { label: 'Scan QR Code', description: "Scan this QR code in the Google Authenticator app", component: ScanQRCode },
  { 
    label: 'Backup Key',
    description: "Please save this Key on paper. This Key will allow you to recover your Google Authenticator in case of phone loss",
    component: BackupKey
  },
  { label: 'Enabled Google Authenticator', description: "Enabled Google Authenticator", component: EnabledGoogleAuthenticator },
];

export const DISABLED_STEPS = [
  { label: 'Download App', description: "Download and install the Google Authenticator app", component: DownloadApp },
  { label: 'Disable Google Authenticator', description: "Disable Google Authenticator", component: DisableGoogleAuthenticator },
];
